<template>
    <div class="xc-page reset xc-page-sandwich">
        <div class="xc-page-main">
            <div class="xc-breadcrumb">
                <router-link :to="$config.adminPath + '/system/user'">系统设置</router-link>
                <a>项目配置</a>
            </div>
            <div class="xc-row xc-s-flex">
                <div class="xc-card">
                    <div class="xc-card-content">
                        <form
                            class="xc-form"
                            name="search"
                            @submit.prevent="mix_search"
                        >
                         
                            <div class="xc-form-inline">
                                <xc-form-item label="服务名称:">
                                    <input
                                        type="text"
                                        name="serviceName"
                                        v-model="mix_query.serviceName"
                                        class="xc-input"
                                        placeholder="请输入服务名称"
                                    >
                                </xc-form-item>
                                <xc-form-item label="状态:">
                                    <select
                                        class="xc-select"
                                        name="stopStatus"
                                        v-model="mix_query.stopStatus"
                                    >
                                        <option value selected>全部</option>
                                        <option value="0">启用</option>
                                        <option value="1">禁用</option>
                                    </select>
                                </xc-form-item>
                                <div class="xc-btn-group">
                                    <button
                                        type="submit"
                                        class="xc-btn xc-btn-primary"
                                    >查询
                                    </button>
                                    <button
                                        class="xc-btn xc-btn-default"
                                        type="button"
                                        @click="add"
                                    >添加
                                    </button>
                                </div>
                            </div>
                        </form>
                        <table class="xc-table">
                            <thead>
                                <tr>
                                    <th>ID</th>
                                    <th>服务项目</th>
                                    <th>服务内容屏展示</th>
                                    <th>是否默认服务项目</th>
                                    <th>上钟语音介绍</th>
                                    <th>下钟语音介绍</th>
                                    <th>状态</th>
                                    <th>操作</th>
                                </tr>
                            </thead>
                            <tbody>
                                <template v-if="list && list.length">
                                    <tr
                                        v-for="(item,index) in list"
                                        :key="index"
                                    >
                                        <td>{{item.serviceId}}</td>
                                        <td>{{item.serviceName}}</td>
                                        <td>{{item.displayText}}</td>
                                        <td>{{item.serviceDefault | defaultStatus}}</td>
                                        <td>
                                            <div class="musicPreview" v-if="item.speechStart" @click="viewMaterial('上钟介绍内容',item.speechStart)">
                                                预览音频文件
                                            </div>
                                        </td>
                                        <td>
                                            <div class="musicPreview" v-if="item.speechEnd" @click="viewMaterial('下钟介绍内容',item.speechEnd)">
                                                预览音频文件
                                            </div>
                                        </td>
                                        <td>{{item.stopStatus | getStatus}}</td>
                                        <td>
                                            <xc-btn-select
                                                title="管理"
                                            >
                                                <template v-if="groups(item).length">
                                                    <xc-btn-select-item
                                                        v-for="(obj,key) in groups(item)"
                                                        :key="key"
                                                        :title="obj.name"
                                                        @click.native="mix_action(obj,item,$event)"
                                                    ></xc-btn-select-item>
                                                </template>
                                            </xc-btn-select>
                                        </td>
                                    </tr>
                                </template>
                                <template v-else>
                                    <tr>
                                        <td
                                            colspan="20"
                                            class="xc-s-tac"
                                        >暂无数据
                                        </td>
                                    </tr>
                                </template>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
        <div class="xc-page-footer">
            <!-- 分页 -->
            <xc-pagination
                @change="pageChange"
                :page="mix_page"
                :total="mix_total"
                :size="mix_pageSize"
            />
        </div>
        <div class="xc-card">
            <!--添加/编辑-->
            <div
                class="xc-modal xc-modal-dialog"
                v-if="modalName =='add' || modalName =='edit'"
            >
                <div
                    class="xc-modal-mask"
                    @click="modalName=null"
                ></div>
                <div class="xc-modal-wrap xc-anim-scaleIn">
                    <div class="xc-modal-content">
                        <div class="xc-modal-header">
                            <div class="xc-modal-title">{{ modalName =='add'?'添加面板控制':'编辑面板控制' }}</div>
                            <div
                                class="xc-modal-close"
                                @click="modalName=null"
                            ></div>
                        </div>
                        <div class="xc-modal-body" style="max-height: 700px;">
                            <form
                                class="xc-form"
                                name="add"
                                data-vv-scope="add"
                            >
                                <xc-form-item
                                    label="服务项目:"
                                    required
                                >
                                    <input
                                        type="text"
                                        name="serviceName"
                                        class="xc-input"
                                        v-validate="'required'"
                                        data-vv-as="服务项目"
                                        v-model="fomData.serviceName"
                                        placeholder="请输入服务项目"
                                        :class="{'xc-input-error':errors.first('serviceName','add')}"
                                    >
                                    <div class="xc-form-item-error-tips">
                                        {{errors.first("serviceName","add")}}
                                    </div>
                                </xc-form-item>
                                <xc-form-item
                                    label="服务编码:"
                                    required
                                >
                                    <input
                                        type="text"
                                        name="serviceCode"
                                        class="xc-input"
                                        v-validate="'required'"
                                        data-vv-as="服务编码"
                                        v-model="fomData.serviceCode"
                                        placeholder="请输入服务编码"
                                        :class="{'xc-input-error':errors.first('serviceCode','add')}"
                                    >
                                    <div class="xc-form-item-error-tips">
                                        {{errors.first("serviceCode","add")}}
                                    </div>
                                </xc-form-item>
                                <xc-form-item
                                    label="是否默认服务项目："
                                    required
                                >
                                    <select
                                        name="serviceDefault"
                                        class="xc-select"
                                        v-validate="'required'"
                                        data-vv-as="是否默认服务项目："
                                        v-model="fomData.serviceDefault"
                                    >
                                        <option
                                            value="0"
                                            selected
                                        >是</option>
                                        <option value="1">否</option>
                                    </select>
                                </xc-form-item>
                               
                                <xc-form-item
                                    label="服务内容屏展示:"
                                    required
                                >
                                    <input
                                        type="text"
                                        name="displayText"
                                        class="xc-input"
                                        v-model="fomData.displayText"
                                        v-validate="'required'"
                                        data-vv-as="服务内容屏展示"
                                        placeholder="请输入内容"
                                        :class="{'xc-input-error':errors.first('displayText','add')}"
                                    >
                                    <div class="xc-form-item-error-tips">
                                        {{errors.first("displayText","add")}}
                                    </div>
                                </xc-form-item>
                                <xc-form-item
                                    label="服务时长:"
                                    required
                                >
                                    <input
                                        type="number"
                                        name="serviceDuration"
                                        class="xc-input"
                                        v-validate="'required'"
                                        v-model="fomData.serviceDuration"
                                        data-vv-as="服务时长"
                                        placeholder="请输入服务时长(分钟)"
                                        :class="{'xc-input-error':errors.first('serviceDuration','add')}"
                                    >
                                    <div class="xc-form-item-error-tips">
                                        {{errors.first("serviceDuration","add")}}
                                    </div>
                                </xc-form-item>
                                <xc-form-item
                                    label="房间状态："
                                    required
                                >
                                    <select
                                        name="stopStatus"
                                        class="xc-select"
                                        v-validate="'required'"
                                        data-vv-as="房间状态"
                                        v-model="fomData.stopStatus"
                                    >
                                        <option
                                            value="0"
                                            selected
                                        >启用</option>
                                        <option value="1">禁用</option>
                                    </select>
                                </xc-form-item>
                                 <xc-form-item
                                    label="播放类型："
                                    required
                                    :error="errors.first('playbackType','add')"
                                >
                                    <select
                                        name="playbackType"
                                        class="xc-select"
                                        v-model="fomData.playbackType"
                                        v-validate="'required'"
                                        data-vv-as="播放类型"
                                        @change="playbackTypeChange"
                                    >
                                        <option
                                            value="TEXT"
                                            selected
                                        >文字转语音</option>
                                        <option value="MP3">语音文件</option>
                                    </select>
                                </xc-form-item>
                                <template  v-if="fomData.playbackType === 'TEXT'">
                                    <xc-form-item 
                                        label="上钟介绍内容:"
                                        required
                                    >
                                        <textarea
                                            name="playbackContentStart"
                                            v-model="fomData.playbackContentStart"
                                            class="xc-textarea"
                                            placeholder="请输入上钟介绍内容"
                                        ></textarea>
                                        <button
                                            type="button"
                                            class="xc-btn xc-btn-primary"
                                            @click="textToAudio('start')"
                                        >
                                        文字转语音
                                        </button>
                                    </xc-form-item>
                                    <xc-form-item 
                                        v-if="fomData.speechStart"
                                        label="上钟语音文件:"
                                    >
                                        <audio controls ref="audio" class="aud">
                                            <source :src="fomData.speechStart" />
                                        </audio>  
                                    </xc-form-item>
                                    <xc-form-item 
                                        label="下钟介绍内容:"
                                        required
                                    >
                                        <textarea
                                            name="playbackContentEnd"
                                            v-model="fomData.playbackContentEnd"
                                            class="xc-textarea"
                                            placeholder="请输入下钟介绍内容"
                                        ></textarea>
                                        <button
                                            type="button"
                                            class="xc-btn xc-btn-primary"
                                            @click="textToAudio('end')"
                                        >
                                        文字转语音
                                        </button>
                                    </xc-form-item>
                                    <xc-form-item 
                                        v-if="fomData.speechEnd"
                                        label="下钟语音文件:"
                                    >
                                        <audio controls ref="audio" class="aud">
                                            <source :src="fomData.speechEnd" />
                                        </audio>  
                                    </xc-form-item>
                                </template>
                                <template  v-if="fomData.playbackType === 'MP3'">
                                    <xc-form-item
                                        label="上钟介绍内容："
                                        style="align-items: inherit"
                                        required
                                        class="position-upload"
                                    >
                                        <xc-upload1
                                            :fileList.sync="onClockContent"
                                            type="0"
                                            accept=".mp3"
                                            :url="uploadUrl"
                                            :multiple="true"
                                            :beforeUpload="beforeUpload"
                                        />
                                        <input
                                            type="file"
                                            class="file-input"
                                            id="file-selector-start"
                                            size="small"
                                            accept=".mp3"
                                            @change="changeFile($event,'start')"
                                            @del="delStart"
                                        />
                                    </xc-form-item>
                                     <xc-form-item
                                        label="下钟介绍内容："
                                        style="align-items: inherit"
                                        required
                                        class="position-upload"
                                    >
                                        <xc-upload1
                                            :fileList.sync="offClockContent"
                                            type="0"
                                            accept=".mp3"
                                            :url="uploadUrl"
                                            :multiple="true"
                                            :beforeUpload="beforeUpload"
                                        />
                                        <input
                                            type="file"
                                            class="file-input"
                                            id="file-selector-end"
                                            size="small"
                                            accept=".mp3"
                                            @change="changeFile($event,'end')"
                                            @del="delEnd"
                                        />
                                    </xc-form-item>
                                </template>

                            </form>
                        </div>
                        <div class="xc-modal-footer xc-flex-center">
                            <div class="xc-btn-group">
                                <button
                                    type="button"
                                    class="xc-btn xc-btn-default"
                                    @click="modalName=null"
                                >取消
                                </button>
                                <button
                                    type="button"
                                    class="xc-btn xc-btn-primary"
                                    @click="addSubmit"
                                >保存
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!--启用/禁用-->
            <div
                class="xc-modal xc-modal-dialog"
                v-if="modalName=='active' || modalName =='disabled'"
            >
                <div
                    class="xc-modal-mask"
                    @click="modalName=null"
                ></div>
                <div class="xc-modal-wrap xc-anim-scaleIn">
                    <div class="xc-modal-content">
                        <div class="xc-modal-header">
                            <div class="xc-modal-title">{{ modalName=='active'?'启用':'禁用' }}</div>
                            <div
                                class="xc-modal-close"
                                @click="modalName = null"
                            ></div>
                        </div>
                        <div class="xc-modal-body xc-flex-center">
                            {{ modalName=='active'?'确定启用该面板控制，启用后将恢复正常？':'确定禁用该面板控制，禁用后该面板不能使用？' }}
                        </div>
                        <div class="xc-modal-footer xc-flex-center">
                            <div class="xc-btn-group">
                                <button
                                    class="xc-btn xc-btn-default"
                                    @click="modalName = null"
                                >取消
                                </button>
                                <button
                                    class="xc-btn xc-btn-primary"
                                    @click="enableSubmit"
                                >确定
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!--删除-->
            <div
                class="xc-modal xc-modal-dialog"
                v-if="modalName=='delete'"
            >
                <div
                    class="xc-modal-mask"
                    @click="modalName=null"
                ></div>
                <div class="xc-modal-wrap xc-anim-scaleIn">
                    <div class="xc-modal-content">
                        <div class="xc-modal-header">
                            <div class="xc-modal-title">删除</div>
                            <div
                                class="xc-modal-close"
                                @click="modalName = null"
                            ></div>
                        </div>
                        <div class="xc-modal-body xc-flex-center">
                            确定删除该信息？
                        </div>
                        <div class="xc-modal-footer xc-flex-center">
                            <div class="xc-btn-group">
                                <button
                                    class="xc-btn xc-btn-default"
                                    @click="modalName = null"
                                >取消
                                </button>
                                <button
                                    class="xc-btn xc-btn-primary"
                                    @click="deleteSubmit"
                                >确定
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import listMixin from '../xc-ui/mixins/list';
import "@/libs/font-awesome"
import "@/libs/vee-validate"
import "@/libs/vue-select"
import "@/utils/form-format"
import xui from "@/xc-ui";
import projectConfig from "@/api/projectConfig"
import Knowledge from "@/api/systemKnowledge"
import myLayerImport from '@/libs/myLayer';
import { uploadFile } from "@/utils/uploadfile";

// ip格式化
import "@/utils/ip-format";

myLayerImport();

export default {
    name: 'systemItems',
    mixins: [listMixin],
    data() {
        return {
            deviceGroupIds:"",
            adminPath: this.$config.adminPath,
            // 列表key
            mix_listKey: 'list',

            // 列表唯一字段
            mix_listId: 'id',

            list: [],
            stores: [], //门店列表
            roles: [],   //角色列表
            // 默认查询参数
            mix_query: {
                serviceName: "",
                stopStatus: ""
            },
            group: [
                {
                    name: "编辑",
                    id: 0
                },
                {
                    name: "删除",
                    id: 1
                },
                {
                    name: "启用",
                    id: 2,
                },
                {
                    name: "禁用",
                    id: 3,
                },
                
            ],
            modalName: null,  //弹窗名称,add表示添加\edit表示编辑
            current: null,  //当前表行
            fomData: {
                serviceDefault: 0,
                stopStatus:0,
                playbackType:'TEXT',
                files:[]
            },  //表单数据
            uploadUrl: "",
            onClockContent:[],//上钟语音文件
            offClockContent:[],//下钟语音文件
        }
    },
    filters: {
        getStatus: function (value) {
            if (value == 0) {
                return "启用"
            }
            return "禁用";
        },
        defaultStatus: function (value) {
            if (value == 0) {
                return "是"
            }
            return "否";
        },
        // getplaybackType:function(value){
        //     if(value == 'TEXT'){
        //         return "文字转语音";
        //     }else if(value =='MP3'){
        //         return "语音文件";
        //     }
        // },
    },
    methods: {
        // 初始化数据
        initData() {
            var _this = this;
            // 默认搜索的数据
            const search = {
                pageNum: this.mix_page,
                pageSize: this.mix_pageSize,
                ...this.mix_query,
            }

            //请求列表数据
            projectConfig.getProjectByPage({params:search}).then(function (ret) {
                //添加mix_checkbox属性
                _this.list = _this.mix_format(ret.data.list);
                _this.mix_total = ret.data.total;
                _this.mix_page = ret.data.pageNum;
                _this.mix_pageSize = ret.data.pageSize;
            }).catch(function (error) {
                console.log(error)
            });
        },
        // 更新分页
        pageChange: function (page, pageSize) {
            this.mix_page = page;
            this.mix_pageSize = pageSize;
            this.initData();
        },
        // 打开添加弹窗
        add() {
            this.modalName = "add";
            this.fomData = {
                serviceDefault: 0,
                stopStatus:0,
                playbackType:'TEXT',
                files:[]
            };
            this.onClockContent = []
            this.offClockContent =[]
        },
        // 操作单条数据
        action(...args) {
            const [action, item] = args;
            this.current = { ...item };
            this.fomData = { ...item };
            switch (action.name) {
                case "编辑":
                    this.modalName = "edit";
                    if(this.current.playbackType === 'MP3'){
                        this.onClockContent = []
                        this.offClockContent =[]
                        setTimeout(()=>{
                            this.onClockContent.push({url:this.current.playbackContentStart,name:'上钟语音介绍内容.mp3'})
                            this.offClockContent.push({url:this.current.playbackContentEnd,name:'下钟语音介绍内容.mp3'})
                        },100)
                    }
                    break;
                case "启用":
                    this.modalName = "active";
                    break;
                case "禁用":
                    this.modalName = "disabled";
                    break;
                case "删除":
                    this.modalName = "delete";
                    break;
                default:
                    break;
            }
        },
        groups: function (item) {
            var arr = this.group.slice(0);
            if (item.stopStatus == 0) {
                //0表示启用,1表示禁用
                arr.splice(2, 1);
            } else {
                arr.splice(3, 1)
            }
            return arr;
        },
        textToAudio(type){
            //文字转语音
            let textContent = this.fomData.playbackContentStart;
            if(type === 'start'){
                //上钟语音
                if(!this.fomData.playbackContentStart){
                    this.$message.waring("请先输入上钟介绍内容！");
                    return
                }
                this.fomData.speechStart = "";
            }else if(type === 'end'){
                //下钟语音
                 if(!this.fomData.playbackContentEnd){
                    this.$message.waring("请先输入下钟介绍内容！");
                    return
                }
                this.fomData.speechEnd = "";
                textContent = this.fomData.playbackContentEnd;
            }
            let loading = xui.loading({
                text: "转换中..."
            });
            Knowledge.textToMp3({text:textContent}).then((res)=>{
                if(type === 'start'){
                    this.fomData.speechStart = res.data;
                } else if(type === 'end'){
                    this.fomData.speechEnd = res.data;
                }
                loading.close();
                this.$forceUpdate()
            })
            
        },
        // 添加确定
        addSubmit: function () {
            var myForm = document.add;
            // 验证器命名空间
            const scope = 'add';
            this.$validator.validateAll(scope).then(validate => {
                if (validate) {
                    const data = this.$formFormat(myForm);
                     if(data.playbackType === 'MP3'){
                        data.playbackContentStart = this.onClockContent[0].url;
                        data.speechStart = this.onClockContent[0].url;
                        data.playbackContentEnd = this.offClockContent[0].url;
                        data.speechEnd = this.offClockContent[0].url;
                    }
                    if(this.fomData.playbackType === 'TEXT' && this.fomData.speechStart == ''){
                        this.$message.waring("请将上钟介绍内容转为语音！");
                        return;
                    }
                    if(this.fomData.playbackType === 'TEXT' && this.fomData.speechEnd == ''){
                        this.$message.waring("请将下钟介绍内容转为语音！");
                        return;
                    }
                    if(this.fomData.playbackType === 'TEXT'){
                        if(this.modalName === "edit"){
                            if (this.current.playbackContentStart != this.fomData.playbackContentStart && this.current.speechStart == this.fomData.speechStart) {
                                this.$message.waring("若要保存上钟介绍内容，请先转为语音文件！");
                                return;
                            }
                            if (this.current.playbackContentEnd != this.fomData.playbackContentEnd && this.current.speechEnd == this.fomData.speechEnd) {
                                this.$message.waring("若要保存下钟介绍内容，请先转为语音文件！");
                                return;
                            }
                        }
                       data.speechStart = this.fomData.speechStart;
                       data.speechEnd = this.fomData.speechEnd;
                    }

                    if(this.modalName === "add"){
                        projectConfig.addProject(data).then(() => {
                            this.$message.success("添加成功");
                            this.modalName = null;
                            this.initData();
                        })
                    }else{
                        data.serviceId = this.current.serviceId;
                        projectConfig.updateProject(data).then(() => {
                            this.$message.success("修改成功");
                            this.modalName = null;
                            this.initData();
                        })
                    }
                } else {
                    // let error = this.errors.items[0].msg;
                    return false;
                }

            })
        },

        //启用、禁用
        enableSubmit: function () {
            var _this = this;
            var currentstatus = 0;
            if(this.modalName=='disabled'){
                currentstatus = 1;
            }
            var obj = {
                serviceId: this.current.serviceId,
                stopStatus: currentstatus
            };
            projectConfig.stopStatus(obj).then(function () {
                var statusText = '启用成功';
                if(_this.modalName === 'disabled'){
                    statusText = '禁用成功';
                }
                _this.$message.success(statusText);
                _this.modalName = null;
                _this.initData();
            }).catch(function (error) {
                console.log(error)
            })
        },
        // 删除确认
        deleteSubmit() {
            projectConfig.deleteProject(this.current.serviceId).then(v => {
                this.$message.success(v.msg);
                this.modalName = null;
                this.initData()
            })
        },
        playbackTypeChange(){
            //强制刷新视图
            this.$forceUpdate()
        },
        beforeUpload(file) {
            if (!this.sysConfig.upload_max_video_size) {
                this.$message.error("上传配置获取识别，请稍后重试");
                return false;
            }
            const maxSize = this.sysConfig.upload_max_video_size.value * 1024 * 1024;
            const passSuffix = this.sysConfig.pass_video_suffix.value.split(",");

            if (file.size > maxSize) {
                this.$message.error(
                "音乐大小不能超过" + this.sysConfig.upload_max_video_size.value + "MB"
                );
                return false;
            }

            const suffixAry = file.name.split(".");
            if (suffixAry.length == 0) {
                this.$message.error(
                "文件格式不正确，请上传" + passSuffix.join(",") + "格式文件"
                );
                return false;
            }

            // 判断是否允许的格式
            const allowType = passSuffix.some((item) => {
                return suffixAry[suffixAry.length - 1] == item;
            });

            // 不允许的文件格式
            if (!allowType) {
                this.$message.error(
                "文件格式不正确，请上传" + passSuffix.join(",") + "格式文件"
                );
                return false;
            }
        },
        changeFile(event,type) {
            let file = event.target.files[0];
            if (!file) return;
            this.loading = true;
            this.cosUploadFile(file,type);
        },
        // 通过腾讯云 cos-js-sdk-v5 上传
        cosUploadFile(file,type) {
            uploadFile(file, async (err, data) => {
                if (err) {
                    console.log(err);
                } else {
                    console.log(data, "data");
                    let fileData = JSON.parse(JSON.stringify(data));
                    var au = document.createElement("audio");
                    au.src = data.fid;
                    this.loading = false;
                    fileData.url = data.fid;
                    fileData.file = data.fid;
                    fileData.md5 = file.md5;
                    fileData.type = file.type;
                    fileData.name = file.name;
                    fileData.size = file.size;
                    fileData.status = "success";
                    if(type === 'start'){
                        //上钟
                        this.onClockContent.push(fileData);
                        this.fomData.playbackContentStart = fileData.url;
                    }
                    if(type === 'end'){
                        //下钟
                        this.offClockContent.push(fileData);
                        this.fomData.playbackContentEnd = fileData.url;
                    }
                }
            });
        },
        delStart() {
            document.getElementById("file-selector-start").value = "";
        },
        delEnd() {
            document.getElementById("file-selector-end").value = "";
        },
         //  预览音频文件
        viewMaterial(name,url) {
            var _this = this;
            myLayer.open({
                type: 2,
                title: false,
                shadeClose: true,
                closeBtn: 0, //不显示关闭按钮
                area: ["981px", "550px"],
                content:
                _this.adminPath +
                "/material/preview?name=" +
                name +
                "&type=audio" +
                "&url=" +
                url,
                success: function () {},
            });
        },
    }
}
</script>

<style  lang="scss">
@import "../xc-ui/scss/variable";
.reset {
    form[name="reset"] {
        .xc-form-item-label {
            width: 80px;
        }
    }
}
.position-upload {
  position: relative;
}
.file-input {
  position: absolute;
  top: 0;
  min-height: 40px;
  opacity: 0;
}
.musicPreview{
    color: #507dde;
    cursor: pointer;
}

</style>

